import { constants } from '#globals';
import { Database, EnvironmentType } from '#types';
import axios, { AxiosRequestConfig, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { dashboardApiV3 } from './dashboardApiV3';

export const clientV3 = axios.create({ baseURL: process.env.REACT_APP_DB_URL as string });

clientV3.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
        const jwtToken = await dashboardApiV3.getToken();
        if (localStorage.getItem(constants.targetEnv) === EnvironmentType.DEVELOPMENT) {
            config.baseURL = process.env.REACT_APP_DB_URL_DEV as string;
        }
        if (localStorage.getItem(constants.targetDb) === Database.SBB) {
            config.baseURL = process.env.REACT_APP_SBB_DB_URL as string;
            if (localStorage.getItem(constants.targetEnv) === EnvironmentType.DEVELOPMENT) {
                config.baseURL = process.env.REACT_APP_SBB_DB_URL_DEV as string;
            }
        }
        if (localStorage.getItem(constants.targetDb) === Database.GD) {
            config.baseURL = process.env.REACT_APP_GD_DB_URL as string;
            if (localStorage.getItem(constants.targetEnv) === EnvironmentType.DEVELOPMENT) {
                config.baseURL = process.env.REACT_APP_GD_DB_URL_DEV as string;
            }
        }
        if (config.headers) {
            config.headers.Accept = 'application/json';
            config.headers['X-App-Identifier'] = localStorage.getItem(constants.targetDb);
            if (jwtToken) {
                config.headers.Authorization = `Bearer ${jwtToken}`;
            }
        }
        return config as InternalAxiosRequestConfig<any>;
    },
    (error) => Promise.reject(error)
);
